import * as React from "react";
import { ODataParams, Query } from "../../Components/Query";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { OverreadStatusIdEnum } from "../../misc/api/apiTypes";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import { DlcoAnalysisSetListTable } from "./DlcoAnalysisSetListTable";


export const DlcoAnalysisListScreen = ({ cachedQuery, setCachedQuery }) => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `session/visit/subject/site/studyId eq ${study.id}`;

        const expandQuery = `session($select=name,overreadChallengeStatus,challengeIsClosed;$expand=visit($select=name;$expand=subject($select=number,typeName;$expand=site($select=number;$expand=study($select=name)))))`;

        const result = await client.client.getDlcoAnalysisSets('started,created,user,id,type,status,sessionId', filter, params.orderby, expandQuery, params.top, params.skip, undefined, true);

        return result;
    }

    return (
        <DocumentTitle title="Dlco Analysis Sets | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh}
                onQueryCompleted={setCachedQuery}
                savedQuery={cachedQuery}
                initialFilters={[
                    { field: "status", condition: "eq", values: [OverreadStatusIdEnum.Pending, OverreadStatusIdEnum.NotStarted] },
                ]}
                initialOrdering={[{ field: "created", condition: "asc" }]}
            >
                <DlcoAnalysisSetListTable />
            </Query>
        </DocumentTitle>
    );
}
